import { render } from "./ButtonsWithIcon.vue?vue&type=template&id=02650ed0&ts=true"
import script from "./ButtonsWithIcon.vue?vue&type=script&lang=ts"
export * from "./ButtonsWithIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__